import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import * as actions from '@appStore/managers/actions';
import { ManagerService } from '@appStore/managers/services';
import { ManagerRolesActionTypes } from '@appStore/managers/actions';

@Injectable()
export class ManagerRolesEffects {
  constructor(private managerService: ManagerService, private actions$: Actions) {}

  loadMyClientRoles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerRolesActionTypes.ManagerRolesLoadData),
      exhaustMap(action => {
        return this.managerService.getMyClientRoles().pipe(
          map(clientRoles => new actions.ManagerRolesLoadSuccess(clientRoles)),
          catchError(error => of(new actions.ManagerRolesLoadFail(error)))
        );
      })
    );
  });
}
